
import Utils from './utils';
import * as keys from './keys';
import isObjectEmpty from 'utils/isObjectEmpty';
import utils from './utils';

const FormObserver = (formRef, props) => {
    let biRequest = props.data.bi_request;
    let liAge = Number(biRequest.LI_ENTRY_AGE)

    formRef.$('PPT').observe({
        key: 'value',
        call: ({ field }) => {
            console.log(field.value.id, "field", formRef.get())
            let planOption = formRef.$("plan-option").value.id
            let pt = formRef.$("PT")?.value?.id
            let ppt = field.value.id
            let requestData = {}

            let planOptionlist = utils.getPlanOptionList(Number(pt), Number(ppt))
            formRef.$("plan-option").set("extra", {
                ...formRef.$("plan-option").extra,
                optionList: planOptionlist
            })

            if (Number(planOption) === 2 && planOptionlist?.length === 1) {
                formRef.$("plan-option").set("value", { id: 1, label: 'Regular income' })
            }
            requestData = {
                ppt: field.value.id,
                pt: pt
            }

            Utils.updateBi(keys.PPT, requestData, props.data.package_id, formRef, props)
        }
    })

    formRef.$('PT').observe({
        key: 'value',
        call: ({ field }) => {
            let pptValue = formRef.$("PPT").value.id
            let planOption = formRef.$("plan-option").value.id

            let planOptionlist = utils.getPlanOptionList(Number(field.value.id), Number(pptValue))
            formRef.$("plan-option").set("extra", {
                ...formRef.$("plan-option").extra,
                optionList: planOptionlist
            })

            if (Number(planOption) === 2 && planOptionlist?.length === 1) {
                formRef.$("plan-option").set("value", { id: 1, label: 'Regular income' })
            }

            let requestData = {
                pt: field.value.id,
                ppt: pptValue
            }
            Utils.updateBi(keys.PT, requestData, props.data.package_id, formRef, props)
        }
    })

    formRef.$('income-duration').observe({
        key: 'value',
        call: ({ field }) => {
            let ppt = formRef.$('PPT')?.value
            let cashback = formRef.$("cashback")?.value?.id
            // if (!isObjectEmpty(ppt)) {
            //     formRef.$('PT').set('value', { label: Number(field?.value?.label) + Number(ppt?.id) + 1, id: Number(field?.value?.label) + Number(ppt?.id) + 1 })
            // }
            //! enable premium offset option when incomeDuration is 30 and PPT is 12 and cashback is NO 36
            if (Number(field?.value?.id) === 7 && Number(ppt?.id) === 12 && Number(cashback) === 36) {
                formRef.$("premium-offset-option").set("value", { label: 'No', id: 50 })
                formRef.$("premium-offset-option").set("extra", {
                    ...formRef.$("premium-offset-option").extra,
                    isVisible: true
                })
            } else {
                formRef.$("premium-offset-option").set("value", { label: 'No', id: 50 })
                formRef.$("premium-offset-option").set("extra", {
                    ...formRef.$("premium-offset-option").extra,
                    isVisible: false
                })
                formRef.$("premium-offset-option-income-start-year").set("value", "")
                formRef.$("premium-offset-option-income-start-year").set("extra", {
                    ...formRef.$("premium-offset-option-income-start-year").extra,
                    isVisible: false
                })
            }
            let requestData = {
                incomeDuration: field.value.id,
                pt: 100
            }
            Utils.updateBi(keys.INCOME_DURATION, requestData, props.data.package_id, formRef, props)
        }
    })

    formRef.$('income-option').observe({
        key: 'value',
        call: ({ field }) => {
            let incomeOption = field.value.id
            let requestData = {}
            let ppt = formRef.$("PPT").value.id

            switch (Number(incomeOption)) {
                case 9:
                    formRef.$("increasing").set("extra", {
                        ...formRef.$("increasing").extra,
                        isVisible: false
                    })

                    formRef.$("timing-of-income-from-income-start-year").set("extra", {
                        ...formRef.$("timing-of-income-from-income-start-year").extra,
                        optionList: [
                            { id: "37", label: 'Start Of Year' },
                            { id: "38", label: 'End Of Year' }
                        ]
                    })

                    formRef.$("income-benefit-payout-start-year").set("extra", {
                        ...formRef.$("income-benefit-payout-start-year").extra,
                        isVisible: true,
                        optionList: [
                            { id: 21, label: 1 },
                            { id: 22, label: 2 },
                            { id: 25, label: 5 }
                        ]
                    })
                    formRef.$('income-benefit-payout-start-year').set('value', { id: 21, label: 1 })


                    requestData = {
                        income_option: incomeOption,
                        increasing: 0
                    }
                    break;

                case 45:
                    formRef.$("timing-of-income-from-income-start-year").set("extra", {
                        ...formRef.$("timing-of-income-from-income-start-year").extra,
                        optionList: [
                            //   { id: "37", label: 'Start Of Year' },
                            { id: "38", label: 'End Of Year' }
                        ]
                    })
                    formRef.$('timing-of-income-from-income-start-year').set('value', { id: "38", label: 'End Of Year' })

                    let incomeBenefitPayoutStartYearValue = { id: Number(ppt) + 22, label: Number(ppt) + 2 }
                    formRef.$("income-benefit-payout-start-year").set("extra", {
                        ...formRef.$("income-benefit-payout-start-year").extra,
                        isVisible: true,
                        optionList: [
                            incomeBenefitPayoutStartYearValue
                        ]
                    })
                    formRef.$('income-benefit-payout-start-year').set('value', incomeBenefitPayoutStartYearValue)


                    requestData = {
                        income_option: incomeOption,
                        increasing: 0
                    }
                    break;

                // case 10:
                //     formRef.$("increasing").set("extra", {
                //         ...formRef.$("increasing").extra,
                //         isVisible: true
                //     })
                //     formRef.$("increasing").set("value", { id: 15, label: "50%" })
                //     requestData = {
                //         income_option: incomeOption ,
                //         increasing: "15"
                //     }
                //     break;

            }
            Utils.updateBi(keys.INCOME_OPTION, requestData, props.data.package_id, formRef, props)
        }
    })

    formRef.$('payment-frequency').observe({
        key: 'value',
        call: ({ field }) => {
            let premium = formRef.$("premium").value;
            let frequency = Number(field.value.id);

            let data = {
                premium: premium,
                frequency: frequency,
            };
            Utils.updateBi(keys.FREQUENCY, data, props.data.package_id, formRef, props)
        }
    })

    formRef.$('income-benefit-pay-out-type').observe({
        key: 'value',
        call: ({ field }) => {
            Utils.updateBi(keys.INCOME_BENEFIT_PAYOUT_TYPE, field.value, props.data.package_id, formRef, props)
        }
    })

    formRef.$('cashback').observe({
        key: 'value',
        call: ({ field }) => {
            let cashback = field.value.id
            let incomeDuration = formRef.$("income-duration").value.id
            let ppt = formRef.$("PPT")?.value?.id
            switch (Number(cashback)) {
                case 35:
                    formRef.$("cashback-percentage").set("extra", {
                        ...formRef.$("cashback-percentage").extra,
                        isVisible: true
                    })
                    formRef.$("cashback-percentage").set("value", { id: "42", label: "20%" })
                    break;

                case 36:
                    formRef.$("cashback-percentage").set("extra", {
                        ...formRef.$("cashback-percentage").extra,
                        isVisible: false
                    })
                    formRef.$("cashback-percentage").set("value", { id: "40", label: "0%" })
                    break;

                default:
                    break;
            }

            //! enable premium offset option when incomeDuration is 30 and PPT is 12 and cashback is NO 36
            if (Number(incomeDuration) === 7 && Number(ppt) === 12 && Number(cashback) === 36) {
                formRef.$("premium-offset-option").set("value", { label: 'No', id: 50 })
                formRef.$("premium-offset-option").set("extra", {
                    ...formRef.$("premium-offset-option").extra,
                    isVisible: true
                })
            } else {
                formRef.$("premium-offset-option").set("value", { label: 'No', id: 50 })
                formRef.$("premium-offset-option").set("extra", {
                    ...formRef.$("premium-offset-option").extra,
                    isVisible: false
                })
                formRef.$("premium-offset-option-income-start-year").set("value", "")
                formRef.$("premium-offset-option-income-start-year").set("extra", {
                    ...formRef.$("premium-offset-option-income-start-year").extra,
                    isVisible: false
                })
            }
            Utils.updateBi(keys.CASHBACK, field.value.id, props.data.package_id, formRef, props)
        }
    })

    formRef.$('increasing').observe({
        key: 'value',
        call: ({ field }) => {
            Utils.updateBi(keys.INCREASING, field.value.id, props.data.package_id, formRef, props)
        }
    })

    formRef.$('cashback-percentage').observe({
        key: 'value',
        call: ({ field }) => {
            Utils.updateBi(keys.CASHBACK_PERCENT_ANNUALISED_PREMIUM, field.value.id, props.data.package_id, formRef, props)
        }
    })
    formRef.$('timing-of-income-from-income-start-year').observe({
        key: 'value',
        call: ({ field }) => {
            Utils.updateBi(keys.TIMING_OF_INCOME_STAR_TYEAR, field.value.id, props.data.package_id, formRef, props)
        }
    })
    formRef.$('income-benefit-payout-start-year').observe({
        key: 'value',
        call: ({ field }) => {
            Utils.updateBi(keys.INCOME_BENEFIT_PAYOUT_START_YEAR, field.value.id, props.data.package_id, formRef, props)
        }
    })
    formRef.$('sum-assure-multiple').observe({
        key: 'value',
        call: ({ field }) => {
            Utils.updateBi(keys.PR_SAMF, field.value.id, props.data.package_id, formRef, props)
        }
    })

    formRef.$('premium-offset-option').observe({
        key: 'value',
        call: ({ field }) => {
            let premiumOffsetOption = field.value.id
            if (Number(premiumOffsetOption) === 49) {
                formRef.$("premium-offset-option-income-start-year").set("value", { label: '5', id: 52 })
                formRef.$("premium-offset-option-income-start-year").set("extra", {
                    ...formRef.$("premium-offset-option-income-start-year").extra,
                    isVisible: true
                })
            } else {
                formRef.$("premium-offset-option-income-start-year").set("extra", {
                    ...formRef.$("premium-offset-option-income-start-year").extra,
                    isVisible: false
                })
            }
            Utils.updateBi(keys.PREMIUM_OFFSET_OPTION, field.value.id, props.data.package_id, formRef, props)
        }
    })

    formRef.$('premium-offset-option-income-start-year').observe({
        key: 'value',
        call: ({ field }) => {

            Utils.updateBi(keys.PREMIUM_OFFSET_OPTION_INCOME_START_YEAR, field.value.id, props.data.package_id, formRef, props)
        }
    })


    formRef.$('is-existing-customer').observe({
        key: 'value',
        call: ({ field }) => {
            Utils.updateBi(keys.IS_EXISTING_CUSTOMER, field.value.id, props.data.package_id, formRef, props)
        }
    })

    formRef.$('is-ecs-mandate').observe({
        key: 'value',
        call: ({ field }) => {
            Utils.updateBi(keys.IS_ECA_MANDATE, field.value.id, props.data.package_id, formRef, props)
        }
    })


    formRef.$('is-income-benefit-advance').observe({
        key: 'value',
        call: ({ field }) => {

            if (Number(field.value.id) === 1) {
                formRef.$('accrual-of-survival-benefit').set('value', { label: 'No', id: "14" })
                formRef.$('accrual-of-survival-benefit').set('disabled', true)
            } else {
                formRef.$('accrual-of-survival-benefit').set('disabled', false)
            }
            Utils.updateBi(keys.IS_INCOME_BENEFIT_ADVANCE, field.value.id, props.data.package_id, formRef, props)
        }
    })

    formRef.$('death-benefit-option').observe({
        key: 'value',
        call: ({ field }) => {
            Utils.updateBi(keys.DEATH_BENEFIT_OPTION, field.value.id, props.data.package_id, formRef, props)
        }
    })

    formRef.$('sum-assured-on-maturity').observe({
        key: 'value',
        call: ({ field }) => {
            Utils.updateBi(keys.SUM_ASSUREDDON_MATURITY, field.value.id, props.data.package_id, formRef, props)
        }
    })


    formRef.$('advantage-benefit-percentage').observe({
        key: 'value',
        call: ({ field }) => {
            Utils.updateBi(keys.ADVANTAGE_BENEFIT_PERCENTAGE, field.value.id, props.data.package_id, formRef, props)
        }
    })

    formRef.$('advantage-benefit-percentage').observe({
        key: 'value',
        call: ({ field }) => {
            Utils.updateBi(keys.ADVANTAGE_BENEFIT_PERCENTAGE, field.value.id, props.data.package_id, formRef, props)
        }
    })

    formRef.$('income-benefit-pay-out-frequency').observe({
        key: 'value',
        call: ({ field }) => {
            Utils.updateBi(keys.INCOME_BENEFIT_PAYOUT_FREQUENCY, field.value.id, props.data.package_id, formRef, props)
        }
    })

    formRef.$('plan-option').observe({
        key: 'value',
        call: ({ field }) => {
            // Accrual Of Survival Benefits
            if (Number(field?.value?.id) === 2) {
                formRef.$('sum-assured-on-maturity').set('value', "")
                formRef.$('sum-assured-on-maturity').set('disabled', true)
                formRef.$('advantage-benefit-percentage').set('disabled', false)
                 formRef.$('advantage-benefit-percentage').set('value', { label: '40%', id: 11 })

            } else {
                formRef.$('sum-assured-on-maturity').set('value', { label: 'Option 1', id: 5 })
                formRef.$('sum-assured-on-maturity').set('disabled', false)
                formRef.$('advantage-benefit-percentage').set('disabled', true)
                formRef.$('advantage-benefit-percentage').set('value', "")

            }
            Utils.updateBi(keys.PLAN_OPTION, field.value.id, props.data.package_id, formRef, props)
        }
    })

    // !Accrual Of Survival Benefits
    formRef.$('accrual-of-survival-benefit').observe({
        key: 'value',
        call: ({ field }) => {

            Utils.handleAsbCondition(formRef, field.value.id)
            let asbStartYear1 = ""
            let asbEndYear1 = ""

            let pt = formRef.$('PT').value.id

            if (field.value.id === 13) {
                Utils.handleASBstartPolicyOneConditions(formRef, props.data.product_name, pt, liAge)

                if (formRef.$('asb-start-age-(1st-opt-in)').value) {
                    asbStartYear1 = formRef.$('asb-start-age-(1st-opt-in)').value.id
                }
                if (formRef.$('asb-end-age-(1st-opt-in)').value) {
                    asbEndYear1 = formRef.$('asb-end-age-(1st-opt-in)').value.id
                }
            }
            // let incomeBenefitAdvance = formRef?.$('is-income-benefit-advance')?.value?.id
            // if (Number(incomeBenefitAdvance) === 1) {
            //     utils.setHideAndResetValue(formRef, "asb-start-age-(1st-opt-in)", true)
            //     utils.setHideAndResetValue(formRef, "asb-end-age-(1st-opt-in)", true)
            //     utils.setHideAndResetValue(formRef, "withdrawal-parcentage-1", true)
            // }
            let requestData = {
                asb1: field.value.id,
                asbStartYear1,
                asbEndYear1
            }
            Utils.updateBi(keys.ACCRUALOFSURVIVALBENEFIT_1, requestData, props.data.package_id, formRef, props)
        }
    })

    formRef.$('asb-start-age-(1st-opt-in)').observe({
        key: 'value',
        call: ({ field }) => {


            let asbEndYearOneList = Utils.fetchASBendPolicyOne(field.value.id, formRef.$("asb-start-age-(1st-opt-in)").extra.optionList, formRef.$("asb-end-age-(1st-opt-in)").extra.preDefinedOptList)
            formRef.$("asb-end-age-(1st-opt-in)").set("extra", {
                ...formRef.$("asb-end-age-(1st-opt-in)").extra,
                optionList: asbEndYearOneList,
            });
            let selectedAsbEndYearOne = asbEndYearOneList.some((item) => item.id === formRef.$("asb-end-age-(1st-opt-in)").value?.id);
            if (!selectedAsbEndYearOne) {
                let optData = asbEndYearOneList.find((item) => item.label === field.value.label)
                formRef
                    .$("asb-end-age-(1st-opt-in)")
                    .set("value", optData);
            }
            // let incomeBenefitAdvance = formRef?.$('is-income-benefit-advance')?.value?.id
            // if (Number(incomeBenefitAdvance) === 1) {
            //     utils.setHideAndResetValue(formRef, "asb-start-age-(1st-opt-in)", true)
            //     utils.setHideAndResetValue(formRef, "asb-end-age-(1st-opt-in)", true)
            //     utils.setHideAndResetValue(formRef, "withdrawal-parcentage-1", true)
            // }

            let requestData = {
                asbStart1: field.value.id
            }
            Utils.updateBi(keys.ASB_STARTPOLICYYEAR_1, requestData, props.data.package_id, formRef, props)
        }
    })


    formRef.$('asb-end-age-(1st-opt-in)').observe({
        key: 'value',
        call: ({ field }) => {
            // let incomeBenefitAdvance = formRef?.$('is-income-benefit-advance')?.value?.id
            // if (Number(incomeBenefitAdvance) === 1) {
            //     utils.setHideAndResetValue(formRef, "asb-start-age-(1st-opt-in)", true)
            //     utils.setHideAndResetValue(formRef, "asb-end-age-(1st-opt-in)", true)
            //     utils.setHideAndResetValue(formRef, "withdrawal-parcentage-1", true)
            // }
            let requestData = {
                asbEnd1: field.value.id || "",
            }
            Utils.updateBi(keys.ASB_ENDPOLICYYEAR_1, requestData, props.data.package_id, formRef, props)
        }
    })

    formRef.$('withdrawal-parcentage-1').observe({
        key: 'value',
        call: ({ field }) => {

            // let incomeBenefitAdvance = formRef?.$('is-income-benefit-advance')?.value?.id
            // if (Number(incomeBenefitAdvance) === 1) {
            //     utils.setHideAndResetValue(formRef, "asb-start-age-(1st-opt-in)", true)
            //     utils.setHideAndResetValue(formRef, "asb-end-age-(1st-opt-in)", true)
            //     utils.setHideAndResetValue(formRef, "withdrawal-parcentage-1", true)
            // }
            Utils.updateBi(keys.ASB_WITHDRAWALPERCENTAGE_1, field.value.id, props.data.package_id, formRef, props)

        }
    })


    formRef.$('ADB').observe({
        key: 'value',
        call: ({ field }) => {
            let adbValue = formRef.$('ADB-dropdown').value
            Utils.updateBi(keys.ADB_RIDER, adbValue, props.data.package_id, formRef, props)
        }
    })

    formRef.$('ATPDRider').observe({
        key: 'value',
        call: ({ field }) => {
            let atpdValue = formRef.$('ATPDRider-dropdown').value
            Utils.updateBi(keys.ATPD_RIDER, atpdValue, props.data.package_id, formRef, props)
        }
    })

    formRef.$('CriticalIllnessRider').observe({
        key: 'value',
        call: ({ field }) => {
            let criticalIllness = formRef.$('CriticalIllnessRider-dropdown').value
            Utils.updateBi(keys.Critical_ILLNESS_RIDER, criticalIllness, props.data.package_id, formRef, props)
        }
    })


    formRef.$('HospitalityCashBenefitRider').observe({
        key: 'value',
        call: ({ field }) => {
            let hospitalityCashBenefit = formRef.$('HospitalityCashBenefitRider-dropdown').value
            Utils.updateBi(keys.HOSPITALITY_CASH_BENEFIT_RIDER, hospitalityCashBenefit, props.data.package_id, formRef, props)
        }
    })

    formRef.$('PayorWaiverBenefitRider-dropdown').observe({
        key: 'value',
        call: ({ field }) => {
            Utils.updateBi(keys.PWB_RIDER, field.value.id, props.data.package_id, formRef, props)
        }
    })

    formRef.$('family-income-benefit-option-dropdown').observe({
        key: 'value',
        call: ({ field }) => {
            if (formRef.$('family-income-benefit-option').value) {
                Utils.updateBi(keys.FAMILY_BENEFIT_INCOME_OPTION, field.value.id, props.data.package_id, formRef, props)
            }
        }
    })
}

export default FormObserver